import useViewport from '@shared/innmaxLib/hooks/useViewport'
import Desktop from './Desktop'
import Mobile from './Mobile'

const InternalMapDashboard = () => {
  const { isMobile } = useViewport()
  return isMobile ? <Mobile /> : <Desktop />
}

export default InternalMapDashboard
